function helperNewDate () {
  return new Date()
}

module.exports = helperNewDate



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperNewDate.js
// module id = TzGx
// module chunks = 141